const TIME_PICKER_OPTIONS = [
    {
        label: 'Digital',
        value: 'digital'
    },
    {
        label: 'Analog',
        value: 'analog'
    }
];
export { TIME_PICKER_OPTIONS };

export default TIME_PICKER_OPTIONS;
